<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação de criação de {{ $t(`${moduleIdentifier}.feed.label`) }}</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        Tem certeza de que deseja criar uma {{ $t(`${moduleIdentifier}.feed.label`).toLowerCase() }} de {{ $t(`${moduleIdentifier}.feed.type.sync.label`) }}?
        <br>
        <form-group v-if="amazonAccounts.length" :columns="12" label="Conta">
          <span v-if="error" class="u-color-danger"><small>Selecione uma conta para criação da carga</small></span>
          <select class="form-select" required="true" v-model="account">
            <option value="">Selecione a conta *</option>
            <option v-for="account in amazonAccounts" :key="account.partnerId" :value="account.partnerId">
              {{ account.shopName }} ({{ account.partnerId }})
            </option>
          </select>
        </form-group>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import api from '@/api'

  export default {
    data: () => ({
      error: false,
      modal: null,
      isVisible: false,
      amazonAccounts: [],
      account: ''
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      moduleIdentifier: {
        type: String,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    async mounted () {
      if (this.moduleIdentifier === 'amazon') {
        this.amazonAccounts = (await api.amazon.getAccounts({})).items
      }
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('option', true)
        if (this.moduleIdentifier === 'amazon') {
          if (this.account !== '') {
            this.error = false
            this.close()
          } else {
            this.error = true
          }
        } else {
          this.close()
        }
      },
      cancel () {
        this.$emit('option', false)
        this.close()
      },
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    computed: {
      selectedMatch () {
        if (!this.product.selectedMatchSku) {
          return false
        }
        return this.product.availableMatches.find(availableMatch => availableMatch.sku === this.product.selectedMatchSku)
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      },
      account (value) {
        this.$emit('account', this.account)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .product-img
    max-width: 75px

  .icon-arrow
    font-size: 25px
    margin: 20px 0
</style>



// WEBPACK FOOTER //
// CreateModal.vue?d79e131a